import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Works() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    api.get("/projects").then((r) => {
      if (mounted) {
        setProjects(r.data);
        setLoading(false);
      }
    }).catch(() => setLoading(false));
    return () => { mounted = false; };
  }, []);

  return (
    <section id="work" className="px-6 md:px-12 lg:px-24 py-32 md:py-48" data-testid="works-section">
      <div className="flex items-end justify-between mb-16 md:mb-24">
        <div>
          <p className="font-body text-xs uppercase tracking-[0.25em] text-neutral-500 mb-6">(02) — Selected Work</p>
          <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Recent <span className="font-serif-italic font-normal">obsessions</span>
            <br />from 2022 → 2024.
          </h2>
        </div>
        <div className="hidden md:block font-body text-xs uppercase tracking-[0.25em] text-neutral-500">
          {projects.length} projects
        </div>
      </div>

      {loading ? (
        <div className="font-body text-sm text-neutral-500" data-testid="works-loading">Loading projects…</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-24 md:gap-10">
          {projects.map((p, i) => {
            const span = i % 3 === 0 ? "md:col-span-8" : i % 3 === 1 ? "md:col-span-5 md:col-start-8" : "md:col-span-7";
            const align = i % 2 === 0 ? "" : "md:mt-32";
            return (
              <motion.div
                key={p.id}
                className={`group ${span} ${align}`}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, delay: 0.05 * i, ease: [0.16, 1, 0.3, 1] }}
              >
                <Link to={`/work/${p.slug}`} className="block text-left" data-testid={`project-card-${i}`} data-cursor="hover">
                  <div className="img-zoom-wrap aspect-[4/3] bg-neutral-200">
                    <img src={p.image_url} alt={p.title} className="w-full h-full object-cover" />
                  </div>
                  <div className="mt-6 flex items-baseline justify-between gap-6">
                    <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight">
                      {p.title}
                    </h3>
                    <span className="font-body text-xs uppercase tracking-[0.2em] text-neutral-500 whitespace-nowrap">
                      {p.year}
                    </span>
                  </div>
                  <p className="font-body text-sm text-neutral-600 mt-2">{p.category}</p>
                </Link>
              </motion.div>
            );
          })}
        </div>
      )}
    </section>
  );
}
